import axios from "axios";

let controller = {};
let responsesData = {};

export async function getPreviouslyOrderedProducts(productIdList) {
    const requestKey = productIdList.join('-');
    if (responsesData[requestKey]) {
        return responsesData[requestKey];
    }
    if (controller[requestKey]) {
        controller[requestKey].abort();
    }
    controller[requestKey] = new AbortController();

    try {
        const res = await axios
            .post('ajax/previously-ordered-products', {
                productIds: productIdList,
            }, {
                signal: controller[requestKey].signal
            });

        responsesData[requestKey] = res.data;
        return res.data;
    } catch (e) {
        return {};
    }
}